import api from 'api'
import { UIUserPermission } from 'api/admin/userPermissions/permissions'
import { RevokeRequest, RevokeResponse } from 'api/admin/userPermissions/types'

function getRoute(permission: UIUserPermission): string {
  switch (permission) {
    case 'permission_admin':
      return '/admin/permissions/revoke/permission_admin'
    case 'support_admin':
      return '/admin/permissions/revoke/support_admin'
    case 'support_specialist':
      return '/admin/permissions/revoke/support_specialist'
    case 'finance_admin':
      return '/admin/permissions/revoke/finance_admin'
    case 'company_scope_manager':
      return '/admin/permissions/revoke/company_scope_manager'
    default:
      permission satisfies never
      throw new Error(`Unhandled permission: ${permission}`)
  }
}

export async function deleteUserPermissions(
  request: RevokeRequest,
  permission: UIUserPermission
): Promise<RevokeResponse> {
  const route = getRoute(permission)
  const result = await api.post(route, {
    permissionId: request.permissionId,
    companyScopeId: request.companyScopeId,
  })

  return result.data as RevokeResponse
}
